import { useState } from "react";
import { Button, FormDialog } from "@cntrl/ui";
import {
  useMyCommunicationPreferences,
  useSaveMyCommunicationPreferences,
} from "../../../app/hooks/useCommunicationPreferences.js";
import { CommunicationPreferences } from "./CommunicationPreferences.js";

/**
 * Settings › Account › "Communication preferences" (ART-285): opens the shared {@link CommunicationPreferences} in a
 * modal, for whoever is signed in. Person-scoped like Change password, so both Settings shells use this one door.
 * Saving swaps the modal to the saved check; there is no route.
 */
export function CommunicationPreferencesButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button type="button" variant="link" onClick={() => setOpen(true)}>
        Communication preferences
      </Button>
      {open && <CommunicationPreferencesModal onClose={() => setOpen(false)} />}
    </>
  );
}

function CommunicationPreferencesModal({ onClose }: { onClose: () => void }) {
  const prefs = useMyCommunicationPreferences();
  const save = useSaveMyCommunicationPreferences();

  return (
    <FormDialog title="Communication preferences" size="sm" onClose={onClose}>
      <CommunicationPreferences
        data={prefs.data}
        isLoading={prefs.isLoading}
        isError={prefs.isError}
        onSave={(changes) => save.mutateAsync(changes)}
        saving={save.isPending}
      />
    </FormDialog>
  );
}
